import { Observable } from "rxjs";

export abstract class NotificationData {
  abstract getNotifications(): Observable<any[]>;

  abstract getAllNotifications(): Observable<any[]>;
}
